import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { VerticalOneColumnLayout } from '@savgroup-front-common/core/atoms/VerticalOneColumnLayout';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LayoutGrid = styled(VerticalOneColumnLayout)<{
  $hasBanner: boolean;
}>`
  @media ${media.maxWidth.sm} {
    padding: ${spacing('lg')} 0;
  }

  padding: ${spacing('xl')} ${spacing(12)};
  background: ${({ theme }) => theme.systemColors.defaultBackground};
  border-radius: ${({ theme }) => theme.tw.radius.md};
`;
